export const isFormDataMissingError = (err) => {
  const data = err?.response?.data;
  if (data == null) return false;
  return data.includes("Signature form response not yet PUT");
};
